/**
 * @desc 保存
 */
const URL = "/rantion-device";
import http, { updateResponse } from "@/http";
export type Response = defs.device.Response;
export function request(body: defs.device.SkuFirmwareRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/skuFirmware/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
